// @ is an alias to /src
import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  positions: [],
  position: {}
}

export const mutations = {
  SET_POSITIONS(state, positions) {
    state.positions = positions
  },
  SET_POSITION(state, position) {
    state.position = position
  },
  ADD_POSITION(state, position) {
    state.positions.push(position)
  },
  EDIT_POSITION(state, position) {
    const index = state.positions.findIndex(
      el => el.position_uuid === position.position_uuid
    )
    if (index !== -1) {
      state.positions.splice(index, 1, position)
    }
  },
  DELETE_POSITION(state, positionUUID) {
    const index = state.positions.findIndex(
      el => el.position_uuid === positionUUID
    )
    if (index !== -1) state.positions.splice(index, 1)
  }
}

export const actions = {
  fetchPositions({ commit }, payload) {
    return ApiService.fetchPositions(payload)
      .then(res => {
        const positions = res.data.data
        commit('SET_POSITIONS', positions)
      })
      .catch(error => {
        throw error
      })
  },
  fetchPosition({ commit, getters, state }, id) {
    if (state.position.position_id === id) {
      return state.position
    }

    const position = getters.getPositionById(id)

    if (position) {
      commit('SET_POSITION', position)
      return position
    } else {
      return ApiService.fetchPosition(id)
        .then(res => {
          const position = res.data
          commit('SET_POSITION', position)
          return position
        })
        .catch(error => {
          throw error
        })
    }
  },
  addPosition({ commit }, payload) {
    return ApiService.addPosition(payload)
      .then(res => {
        const position = res.data
        commit('ADD_POSITION', position)
      })
      .catch(error => {
        throw error
      })
  },
  editPosition({ commit }, payload) {
    return ApiService.editPosition(payload)
      .then(res => {
        const position = res.data
        commit('EDIT_POSITION', position)
      })
      .catch(error => {
        throw error
      })
  },
  deletePosition({ commit }, payload) {
    return ApiService.deletePosition(payload)
      .then(() => {
        commit('DELETE_POSITION', payload.positionUUID)
      })
      .catch(error => {
        throw error
      })
  }
}

export const getters = {
  getPositionById: state => id => {
    return state.positions.find(el => el.position_id === id)
  }
}
